import { useEffect, useRef } from 'react';

// Marks intersecting entries as revealed and stops observing them
function revealEntries(entries, observer) {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      entry.target.classList.add('revealed');
      observer.unobserve(entry.target);
    }
  });
}

// Adds 'revealed' class when element scrolls into view
export default function useReveal(options = {}) {
  const ref = useRef(null);
  // Options are captured once on mount; they are static per call-site,
  // and a ref avoids re-running the effect for a new object identity each render.
  const optionsRef = useRef(options);

  useEffect(() => {
    const el = ref.current;
    if (!el) return undefined;
    const observer = new IntersectionObserver(
      (entries) => revealEntries(entries, observer),
      { threshold: 0.15, ...optionsRef.current }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return ref;
}
